import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import envConfig from '../config/config';

const ApiAccessContext = createContext();

export const ApiAccessProvider = ({ children }) => {
    const { accounts } = useMsal();
    const email = accounts[0]?.username.toLowerCase();
    const [apiAccessRole, setApiAccessRole] = useState('user');
    const [apiAccessLoading, setApiAccessLoading] = useState();


    const getAccessRole = ({ roleChange, roleChangeStatus }) => {
        if (roleChange === 'publisher' && roleChangeStatus === 'pending') return 'pending';
        if (roleChange === 'publisher' && roleChangeStatus === 'approved') return 'publisher';
        return 'user';
    };

    useEffect(() => {
        if (!email) return;

        const fetchApiRepoAccess = async () => {
            try {
                setApiAccessLoading(true);
                const { data } = await axios.get(`${envConfig.REACT_APP_APIREPO_LOGIN}/apirepo/v0.1/user/${email}`);
                setApiAccessRole(getAccessRole(data));


            } catch (err) {
                console.error('Failed to fetch API repo access status:', err);
                setApiAccessRole('user');
            } finally {
                setApiAccessLoading(false);
            }
        };

        fetchApiRepoAccess();
    }, [email]);


    return (
        <ApiAccessContext.Provider value={{ apiAccessRole, apiAccessLoading }}>
            {children}
        </ApiAccessContext.Provider>
    );
};

export const useApiAccess = () => useContext(ApiAccessContext);
